import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';
// import { BellOff } from '@peacecover/icon';
import ProfileAvatar from '../../my-page/components/ProfileAvatar';
import { daysSinceInclusive, transformDateToInputValue } from '../../../utils/DateUtil';
import type { ChatRoomType } from '../types/ChatMessageType';

const BettieChatCard = ({ chatRoom }: { chatRoom: ChatRoomType }) => {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() =>
        navigate(`/bettie-chats/${chatRoom.chatRoomId}`, {
          state: { from: 'bettie-chat-list' }
        })
      }
      key={chatRoom.chatRoomId}
      className="w-full bg-pure-white dark:bg-background-elevated dark:border dark:border-[#121212] rounded-[20px] shadow-[0_0_2px_0_rgba(0,0,0,0.05),_0_0_10px_0_rgba(0,0,0,0.08)] dark:shadow-[0_0_2px_0_rgba(0,0,0,0.83),_0_0_10px_0_rgba(0,0,0,0.40)]"
    >
      <div className="flex items-center justify-between px-[20px] py-[14px] border-b border-surface-lv2">
        <p className="text-[12px] font-medium leading-[14px] text-text-main-lv2">
          {t('BettieChatList.dDay', { count: daysSinceInclusive(chatRoom.createdAt) })}
        </p>
        <p className="text-[12px] leading-[14px] text-text-main-lv3">
          {transformDateToInputValue(chatRoom.createdAt).replace(/-/g, '.')}~
        </p>
      </div>
      <div className="flex items-center gap-[10px] px-[20px] py-[15px]">
        <ProfileAvatar
          thumbnailUrl={chatRoom.bettieProfile.thumbnailUrl}
          widthAndHeight="48px"
          svgWidthAndHeight="32px"
          className="flex-shrink-0"
        />
        <div className="flex flex-col gap-[4px] items-start">
          <div className="flex items-center gap-[4px]">
            <p className="text-[15px] font-semibold leading-[18px] text-text-main-lv2">
              {chatRoom.bettieProfile.nickname}
            </p>
            {/* <BellOff size={14} className="text-[#B9B9B9]" /> */}
          </div>
          <p className="text-[13px] leading-[16px] text-text-main-lv3 line-clamp-2 max-w-[200px] text-left">
            {chatRoom.lastMessage?.content}
          </p>
        </div>
      </div>
    </button>
  );
};

export default BettieChatCard;
